<template>
  <div class="content">
    <div class="col-md-8 flex-container-top">
      <h2 class="text-eveer">Add Events</h2>
      <base-button
        type="primary"
        round
        icon
        class="top-button"
        @click="$router.push('add?id=-1')"
      >
        <i class="fa fa-plus"></i>
      </base-button>
    </div>

    <div class="row mt-2">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <!-- <h4 slot="header" class="card-title">Add Events</h4> -->
          <table class="table">
            <thead>
              <tr>
                <th>Events</th>
                <th>Select</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Soccer</td>

                <td>
                  <input
                    type="checkbox"
                    name="soccer"
                    id="soccer"
                    v-model="soccerCheck"
                    value="soccer"
                  />
                </td>
              </tr>
              <tr>
                <td>other</td>
                <td>
                  <input
                    type="checkbox"
                    name="other"
                    id="other"
                    v-model="otherCheck"
                    value="other"
                  />
                </td>
              </tr>

              <tr>
                <td>other 2</td>
                <td>
                  <input
                    type="checkbox"
                    name="other2"
                    id="other2"
                    v-model="other2Check"
                    value="other2"
                  />
                </td>
              </tr>
              <tr>
                <base-button
                  native-type="submit"
                  type="primary"
                  value="Compares"
                  @click="Add()"
                  class="btn-fill"
                  :disabled="loading"
                  >Update</base-button
                >
              </tr>
            </tbody>
          </table>
        </card>
      </div>
    </div>

    <div class="row loader-pos">
      <div class="sk-chase" v-if="loading">
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
      </div>

      <div class="no-data-message" v-if="noDataMessage">
        <div>There are no records found</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    data() {
      return {
        events: [],
        event: [],
        soccerCheck: "",
        otherCheck: "",
        other2Check: "",

        soccer: "",
        other: "",
        other2: "",
      };
    },
    async Add() {
      debugger;

      let event = [];

      var id = this.$route.query.id;
      if (this.soccerCheck == true) {
        event.push("Soccer");
      }

      if (this.otherCheck == true) {
        event.push("Other");
      }

      if (this.other2Check == true) {
        event.push("Other2")
      }
      this.loading = true;

      var add = await this.$apiService.postCall("admin/updateEvents/", {
        _id: id,
        events:event
      
      });
      console.log(add);
      debugger;
      this.$apiService.notify("Events has been Updated.");
      this.$router.push("/organizers/list");
    },
  },
};
</script>
<style>
.pagination-select,
.search-input {
  width: 200px;
}
.swal2-icon-content {
  font-size: inherit !important;
}
</style>
